import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { map } from 'rxjs/operators';

import { APP_PATHS_SLASH } from '@app/core/enums/paths/app.paths';
import { AuthStore } from '@store/auth.store';

export const authGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const redirectToLogin = (): false => {
    const hostCodeName = authStore.hostCodeName();
    localStorage.setItem('redirectUrl', router.url);
    router.navigate([APP_PATHS_SLASH.SIGN_IN], {
      queryParams: hostCodeName ? { externalCodeName: hostCodeName } : undefined,
    });
    return false;
  };

  if (authStore.isAuthenticated()) {
    if (!authStore.isAccessTokenExpired()) {
      return true;
    }

    if (authStore.hasRefreshToken()) {
      return authStore.refresh().pipe(
        map(success => {
          if (success) {
            return true;
          }
          return redirectToLogin();
        })
      );
    }

    return redirectToLogin();
  }

  if (authStore.hasRefreshToken()) {
    return authStore.refresh().pipe(
      map(success => {
        if (success) {
          return true;
        }
        return redirectToLogin();
      })
    );
  }

  return redirectToLogin();
};
